module.exports = __webpack_public_path__ + "static/media/ST3-BG1.7e6493a4.jpg";